import React from 'react';
import { Job, JobSchritt, formatiereZeit } from '../types';

interface JobMonitorProps {
  job: Job;
  onFortsetzen: () => void;
  laeuft: boolean;
}

/**
 * Zeigt einen laufenden/abgeschlossenen Job an: Kopfzeile mit Status und
 * "Fortsetzen"-Knopf bei FEHLER, PROD-Freigabe-Hinweis und die Schrittliste
 * je Instanz. Wird sowohl von der Rollout- als auch von der
 * Provisionieren-Seite verwendet — keine Duplikation der Schrittdarstellung.
 */
const JobMonitor: React.FC<JobMonitorProps> = ({ job, onFortsetzen, laeuft }) => {
  const nachInstanz: Record<string, JobSchritt[]> = {};
  for (const s of job.schritte) {
    if (!nachInstanz[s.instanz_slug]) nachInstanz[s.instanz_slug] = [];
    nachInstanz[s.instanz_slug].push(s);
  }

  return (
    <section className="k-block">
      <h2 className="k-h2">
        Job #{job.id} — {job.status}
        {job.status === 'FEHLER' && (
          <button className="k-btn k-btn--geist" onClick={onFortsetzen} disabled={laeuft}>
            Fortsetzen
          </button>
        )}
      </h2>
      {job.status === 'WARTET_FREIGABE' && (
        <div className="k-hinweis">
          Dieser Rollout betrifft eine PROD-Instanz und wartet auf Freigabe.
          {job.freigabe_gesendet
            ? ' Eine Benachrichtigung wurde an die internen Ansprechpartner gesendet.'
            : ' Kein Mailversand konfiguriert — bitte den Link selbst weitergeben:'}
          {job.freigabe_link && (
            <div className="k-mono" style={{ marginTop: 8, wordBreak: 'break-all' }}>
              {job.freigabe_link}
            </div>
          )}
        </div>
      )}
      {Object.entries(nachInstanz).map(([slug, schritte]) => (
        <div key={slug} className="k-block">
          <h3 className="k-mono">{slug}</h3>
          <div className="k-tabelle__rahmen">
            <table className="k-tabelle">
              <thead>
                <tr>
                  <th>Schritt</th>
                  <th>Status</th>
                  <th>Zeitpunkt</th>
                  <th>Log</th>
                </tr>
              </thead>
              <tbody>
                {schritte.map((s, idx) => (
                  <tr key={idx}>
                    <td>{s.name}</td>
                    <td>{s.status}</td>
                    <td className="k-mono">{formatiereZeit(s.ts)}</td>
                    <td className="k-mono">{s.log || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </section>
  );
};

export default JobMonitor;
